import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/customerOilStorage',
    meta: { title: '客户存油' },
    component: Layout,
    redirect: '/customerOilStorage/list',
    children: [
      {
        path: 'list',
        meta: { title: '客户存油', activeMenu: '/customerOilStorage' },
        component: () => import('@/views/customerOilStorage/CustomerOilStorage.vue')
      },
      {
        path: 'detail',
        meta: { title: '客户存油详情', activeMenu: '/customerOilStorage' },
        component: () => import('@/views/customerOilStorage/CustomerOilStorageDetail.vue')
      }

    ]
  }

]
